(function () {
  "use strict";

  var SELECTOR = "[data-chupps-morph-model]";

  function readConfig(root) {
    var configScript = root.querySelector("[data-chupps-morph-config]");
    if (!configScript) return null;

    try {
      return JSON.parse(configScript.textContent);
    } catch (error) {
      console.error("Chupps Morph Model: invalid section configuration.", error);
      return null;
    }
  }

  function padFrame(index, digits) {
    return String(index).padStart(digits, "0");
  }

  function getFrameName(config, index, prefix) {
    return prefix + padFrame(index, config.frameDigits) + "." + config.frameExtension;
  }

  function getFrameUrl(config, index, prefix) {
    var frameName = getFrameName(config, index, prefix);
    return config.firstFrameUrl.replace(config.firstFrameAsset, frameName);
  }

  function setProgress(root, progress) {
    // Disabled inline transform updates since progress bar animates infinitely styled via CSS keyframes
  }

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function init(root) {
    if (root.dataset.chuppsInitialized === "true") return;

    var config = readConfig(root);
    if (!config) return;

    var canvas = root.querySelector("[data-chupps-canvas]");
    var scrollContainer = root.querySelector("[data-chupps-scroll]");
    var textOverlay = root.querySelector("[data-chupps-text-overlay]");
    var preloader = root.querySelector("[data-chupps-preloader]");
    var loadingMessage = root.querySelector("[data-chupps-loading-message]");
    var section = root.closest(".chupps_morph_model") || root;
    var shopifySection = section.closest(".shopify-section.section-chupps_morph_model");
    var interactionElement = shopifySection || section;

    if (!canvas || !scrollContainer || !preloader) return;
    if (!window.gsap || !window.ScrollTrigger) {
      var attempts = Number(root.dataset.chuppsGsapAttempts || 0);
      if (attempts < 100) {
        root.dataset.chuppsGsapAttempts = String(attempts + 1);
        window.setTimeout(function () {
          init(root);
        }, 50);
        return;
      }
      console.error("Chupps Morph Model: GSAP and ScrollTrigger must load before initialization.");
      return;
    }

    root.dataset.chuppsInitialized = "true";
    config.scrub = toNumber(config.scrub, 0.3);
    if (config.scrub <= 0) config.scrub = 0.3;
    config.mobileScrub = toNumber(config.mobileScrub, config.scrub);
    if (config.mobileScrub <= 0) config.mobileScrub = config.scrub;
    config.scrollHeightVh = toNumber(config.scrollHeightVh, 750);
    if (config.scrollHeightVh <= 0) config.scrollHeightVh = 750;
    config.mobileScrollHeightVh = toNumber(config.mobileScrollHeightVh, 350);
    if (config.mobileScrollHeightVh <= 0) config.mobileScrollHeightVh = 350;
    config.canvasScaleMobile = toNumber(config.canvasScaleMobile, 0.95);
    config.canvasScaleTablet = toNumber(config.canvasScaleTablet, 0.62);
    config.canvasScaleDesktop = toNumber(config.canvasScaleDesktop, 0.85);
    config.canvasScaleLargeMonitor = toNumber(config.canvasScaleLargeMonitor, 0.9);
    config.largeMonitorMinWidth = toNumber(config.largeMonitorMinWidth, 1600);
    config.mobileBreakpoint = toNumber(config.mobileBreakpoint, 768);
    config.tabletBreakpoint = toNumber(config.tabletBreakpoint, 1024);
    config.mobileAutoPlayDuration = toNumber(config.mobileAutoPlayDuration, 3.0);
    if (config.mobileAutoPlayDuration <= 0) config.mobileAutoPlayDuration = 3.0;
    config.enableDesktopAutoPlay = config.enableDesktopAutoPlay !== false;
    config.desktopAutoPlayDuration = toNumber(config.desktopAutoPlayDuration, 10.0);
    if (config.desktopAutoPlayDuration <= 0) config.desktopAutoPlayDuration = 10.0;
    config.desktopPreloadConcurrency = Math.min(600, Math.max(1, Math.round(toNumber(config.desktopPreloadConcurrency, 12))));
    config.mobilePreloadConcurrency = Math.min(600, Math.max(1, Math.round(toNumber(config.mobilePreloadConcurrency, 12))));
    config.mobileFramePrefix = config.mobileFramePrefix || "m_frame_";
    config.svgUrls = Array.isArray(config.svgUrls) ? config.svgUrls : [];
    config.preloaderMessages = Array.isArray(config.preloaderMessages) ? config.preloaderMessages : [];
    if (["left", "center", "right"].indexOf(config.canvasAlignment) === -1) config.canvasAlignment = "center";
    if (!config.backgroundColor) config.backgroundColor = "#FFFFFF";

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);

    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
      document.body.classList.add("chupps-is-ios");
    }

    var ctx = canvas.getContext("2d", { alpha: false });
    var frames = new Array(config.totalFrames);
    var svgImages = {};
    var state = { frame: 0, lastDrawn: -1 };
    var hasInteracted = false;
    var isAnimationCompleted = false;
    var idleTween = null;
    var frameTween = null;
    var cssW = 0;
    var cssH = 0;
    var cancelled = false;
    var targetProgress = 0;
    var lastTouchY = null;
    var currentIsMobile = isMobileViewport();
    var activeFramePrefix = getActiveFramePrefix();
    var loadGeneration = 0;
    var activeSvgIndex = -1;
    var lastMessageBucket = -1;
    var messageAnimationFrame = null;
    var preloadScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var lastWidth = window.innerWidth || document.documentElement.clientWidth || 0;

    function isMobileViewport() {
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var isPortraitTablet = viewportWidth >= config.mobileBreakpoint && viewportWidth <= config.tabletBreakpoint && viewportHeight > viewportWidth;
      return viewportWidth < config.mobileBreakpoint || isPortraitTablet;
    }

    // Dynamic scale depending on viewport width and config rules
    function getCanvasScale() {
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      if (viewportWidth >= config.largeMonitorMinWidth) return config.canvasScaleLargeMonitor;
      if (isMobileViewport()) return config.canvasScaleMobile;
      if (viewportWidth < config.tabletBreakpoint) return config.canvasScaleTablet;
      return config.canvasScaleDesktop;
    }

    function getAlignmentMargins() {
      if (config.canvasAlignment === "left") return { marginLeft: "0", marginRight: "auto" };
      if (config.canvasAlignment === "right") return { marginLeft: "auto", marginRight: "0" };
      return { marginLeft: "auto", marginRight: "auto" };
    }

    function getActiveFramePrefix() {
      return isMobileViewport() ? config.mobileFramePrefix : config.framePrefix;
    }

    function getPreloadConcurrency() {
      return isMobileViewport() ? config.mobilePreloadConcurrency : config.desktopPreloadConcurrency;
    }

    function lockPageScroll() {
      preloadScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add("chupps_morph_model--preloading");
      document.body.classList.add("chupps_morph_model--preloading");
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove("chupps_morph_model--preloading");
      document.body.classList.remove("chupps_morph_model--preloading");
    }

    function preventPreloadScroll(event) {
      if (!preloader || preloader.classList.contains("fade-out") || preloader.classList.contains("loaded")) return;
      event.preventDefault();
      window.scrollTo(0, preloadScrollY);
    }

    function getProgressMessage(progress) {
      var bucket = Math.min(10, Math.max(0, Math.floor(progress / 10)));
      return config.preloaderMessages[bucket] || config.preloaderMessages[0] || "";
    }

    function setLoadingMessage(progress) {
      if (!loadingMessage) return;
      var bucket = Math.min(10, Math.max(0, Math.floor(progress / 10)));
      if (bucket === lastMessageBucket) return;

      var nextText = getProgressMessage(progress);
      lastMessageBucket = bucket;
      if (messageAnimationFrame) window.cancelAnimationFrame(messageAnimationFrame);
      loadingMessage.textContent = "";

      var startedAt = window.performance.now();
      var duration = Math.max(350, nextText.length * 28);

      function type(now) {
        var progressRatio = Math.min(1, (now - startedAt) / duration);
        var chars = Math.round(nextText.length * progressRatio);
        loadingMessage.textContent = nextText.slice(0, chars);
        if (progressRatio < 1) {
          messageAnimationFrame = window.requestAnimationFrame(type);
        }
      }

      messageAnimationFrame = window.requestAnimationFrame(type);
    }

    function updatePreloadProgress(progress) {
      setProgress(root, progress);
      setLoadingMessage(progress);
    }

    function render(force) {
      var idx = Math.max(0, Math.min(config.totalFrames - 1, Math.round(state.frame)));
      if (!force && idx === state.lastDrawn) return;

      var img = frames[idx];
      window.__renderedFrame = idx;
      if (!img || !img.complete || img.naturalWidth === 0) return;

      state.lastDrawn = idx;

      ctx.fillStyle = config.backgroundColor;
      ctx.fillRect(0, 0, cssW, cssH);
      ctx.drawImage(img, 0, 0, cssW, cssH);
      updateTextOverlay(idx);

      // Lock animation state if we reached the final frame once
      if (idx >= config.totalFrames - 2) {
        isAnimationCompleted = true;
      }
    }

    function getSvgIndexForFrame(frameNumber) {
      if (frameNumber >= 56 && frameNumber <= 87) return 0;
      if (frameNumber >= 88 && frameNumber <= 183) return 1;
      if (frameNumber >= 184 && frameNumber <= 220) return 2;
      if (frameNumber >= 221 && frameNumber <= 414) return 3;
      if (frameNumber >= 415 && frameNumber <= 555) return 4;
      return -1;
    }

    function positionTextOverlay() {
      if (!textOverlay) return;
      var mobile = isMobileViewport();
      
      var left, top, width, height, transform;
      if (mobile) {
        var scale = 0.85;
        left = "50%";
        top = (cssH * 0.950) + "px";
        width = (cssW * 0.956) + "px";
        height = (cssH * 0.118) + "px";
        transform = "translateX(-50%) scale(" + scale + ")";
        canvas.style.transform = "none";
      } else {
        left = "0px";
        top = cssH * 0.851852 + "px";
        width = cssW * 1 + "px";
        height = cssH * 0.109259 + "px";
        transform = "none";
        canvas.style.transform = "none";
      }

      textOverlay.style.left = left;
      textOverlay.style.top = top;
      textOverlay.style.width = width;
      textOverlay.style.height = height;
      textOverlay.style.transform = transform;
      textOverlay.style.transformOrigin = "center center";
    }

    function updateTextOverlay(frameIndex) {
      if (!textOverlay) return;

      var nextSvgIndex = getSvgIndexForFrame(frameIndex + 1);
      var mobile = isMobileViewport();
      var svgUrlsArray = mobile && config.mobileSvgUrls ? config.mobileSvgUrls : config.svgUrls;
      var nextUrl = nextSvgIndex >= 0 ? svgUrlsArray[nextSvgIndex] : "";

      if (!nextUrl) {
        textOverlay.hidden = true;
        activeSvgIndex = -1;
        return;
      }

      if (activeSvgIndex !== nextSvgIndex) {
        textOverlay.src = nextUrl;
        activeSvgIndex = nextSvgIndex;
      }

      textOverlay.hidden = false;
      positionTextOverlay();
    }

    function getRenderedModelSize() {
      var img = frames[Math.max(0, Math.min(config.totalFrames - 1, Math.round(state.frame)))] || frames[0];
      var ratio = img && img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 1;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
      var header = document.querySelector('header') || document.querySelector('.theme__header') || document.querySelector('.header__wrapper');
      var headerHeight = header ? header.offsetHeight : 0;
      
      var mobile = isMobileViewport();
      var scale = getCanvasScale();
      var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (mobile && isIOS) {
        // Boost canvas scale slightly on iOS to match Android, but cap at 0.90 to keep text overlay visible
        scale = Math.min(0.90, scale * 1.06);
      }
      
      var availableHeight = window.innerHeight - headerHeight;
      var height = Math.max(1, availableHeight * scale);
      var width = Math.max(1, height * ratio);
      var maxWidth = Math.max(1, viewportWidth);

      if (width > maxWidth) {
        width = maxWidth;
        height = Math.max(1, width / ratio);
      }

      return {
        width: width,
        height: height
      };
    }

    function applyRenderedModelSize() {
      var size = getRenderedModelSize();
      var width = size.width + "px";
      var height = size.height + "px";
      var margins = getAlignmentMargins();

      section.style.width = width;
      section.style.marginLeft = margins.marginLeft;
      section.style.marginRight = margins.marginRight;
      if (shopifySection) {
        shopifySection.style.width = "100%";
        shopifySection.style.marginLeft = "0";
        shopifySection.style.marginRight = "0";
        shopifySection.style.background = config.backgroundColor;
      }
      root.style.width = width;
      root.style.height = height;
      root.style.marginLeft = margins.marginLeft;
      root.style.marginRight = margins.marginRight;
      scrollContainer.style.width = width;
      scrollContainer.style.height = height;
      canvas.style.width = width;
      canvas.style.height = height;
    }

    function updateHeaderHeight() {
      var header = document.querySelector('header') || document.querySelector('.theme__header') || document.querySelector('.header__wrapper');
      var headerHeight = header ? header.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }

    function updateMarginOnScroll() {
      if (!root || !section) return;
      var stageHeight = root.offsetHeight;
      var mobile = isMobileViewport();
      
      var top1, height1, textOverlayBottom;
      if (mobile) {
        top1 = cssH * 0.950;
        height1 = cssH * 0.118;
        // visual bottom is top1 + (height1 / 2) * (1 + scale)
        textOverlayBottom = top1 + (height1 / 2) * 1.85;
      } else {
        top1 = cssH * 0.851852;
        height1 = cssH * 0.109259;
        textOverlayBottom = top1 + height1;
      }
      var emptySpace = stageHeight - textOverlayBottom;
      
      if (emptySpace > 0) {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var effectiveScrollY = isAnimationCompleted ? scrollY : 0;
        var appliedMargin = -Math.min(emptySpace, effectiveScrollY);
        section.style.marginBottom = appliedMargin + "px";
      } else {
        section.style.marginBottom = (-emptySpace) + "px";
      }
    }

    function resize(force) {
      var newWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      var mobile = isMobileViewport();
      
      if (force !== true && mobile && newWidth === lastWidth) {
        return;
      }
      lastWidth = newWidth;

      updateHeaderHeight();
      var nextIsMobile = isMobileViewport();
      if (nextIsMobile !== currentIsMobile) {
        currentIsMobile = nextIsMobile;
        reloadFramesForViewport(nextIsMobile);
        // Force reload active overlay index to swap textures/src correctly
        activeSvgIndex = -1;
        updateTextOverlay(Math.round(state.frame));
      }

      applyRenderedModelSize();
      var dpr = Math.min(window.devicePixelRatio || 1, config.maxDevicePixelRatio);
      cssW = canvas.clientWidth;
      cssH = canvas.clientHeight;
      canvas.width = Math.floor(cssW * dpr);
      canvas.height = Math.floor(cssH * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      state.lastDrawn = -1;
      render(true);
      positionTextOverlay();
      updateMarginOnScroll();
    }

    function reloadFramesForViewport(nextIsMobile) {
      currentIsMobile = nextIsMobile;
      activeFramePrefix = getActiveFramePrefix();
      loadGeneration += 1;
      frames = new Array(config.totalFrames);
      state.lastDrawn = -1;
      activeSvgIndex = -1;

      var generation = loadGeneration;
      loadFrames({
        generation: generation,
        prefix: activeFramePrefix,
        includeSvgs: false,
        reportProgress: false
      }).then(function () {
        if (cancelled || generation !== loadGeneration) return;
        if (hasInteracted) {
          state.frame = targetProgress * (config.totalFrames - 1);
        }
        resize(true);
      });
    }

    function loadFrames(options) {
      options = options || {};
      var generation = options.generation || loadGeneration;
      var prefix = options.prefix || activeFramePrefix;
      var includeSvgs = options.includeSvgs === true;
      var reportProgress = options.reportProgress === true;
      var loaded = 0;
      var order = [];
      var cursor = 0;
      var activeSvgUrls = isMobileViewport() && config.mobileSvgUrls ? config.mobileSvgUrls : config.svgUrls;
      var svgUrlsToLoad = includeSvgs ? activeSvgUrls.filter(Boolean) : [];
      var totalAssets = config.totalFrames + svgUrlsToLoad.length;

      function markLoaded() {
        loaded += 1;
        if (!cancelled && reportProgress) {
          updatePreloadProgress(Math.round((loaded / totalAssets) * 100));
        }
      }

      for (var idleIndex = 0; idleIndex < config.idleLoopEnd; idleIndex += 1) order.push(idleIndex);
      for (var frameIndex = config.idleLoopEnd; frameIndex < config.totalFrames; frameIndex += 1) order.push(frameIndex);

      function loadOne(index) {
        return new Promise(function (resolve) {
          var img = new Image();
          img.decoding = "async";
          img.src = getFrameUrl(config, index + 1, prefix);

          function done() {
            markLoaded();
            if (!cancelled && generation === loadGeneration) {
              frames[index] = img;
            }
            resolve();
          }

          img.onload = done;
          img.onerror = done;
        });
      }

      function loadSvg(url) {
        return new Promise(function (resolve) {
          if (!url || svgImages[url]) {
            if (url) markLoaded();
            resolve();
            return;
          }

          var img = new Image();
          img.decoding = "async";
          img.src = url;

          function done() {
            svgImages[url] = img;
            markLoaded();
            resolve();
          }

          img.onload = done;
          img.onerror = done;
        });
      }

      function worker() {
        if (cancelled || cursor >= order.length) return Promise.resolve();
        var index = order[cursor];
        cursor += 1;
        return loadOne(index).then(worker);
      }

      var workers = [];
      for (var i = 0; i < getPreloadConcurrency(); i += 1) workers.push(worker());

      var svgLoads = svgUrlsToLoad.map(loadSvg);
      return Promise.all(workers.concat(svgLoads));
    }

    function getVirtualDistance() {
      var distanceVh = isMobileViewport() ? config.mobileScrollHeightVh : config.scrollHeightVh;
      return Math.max(50, (distanceVh / 100) * window.innerHeight);
    }

    function getActiveScrub() {
      return isMobileViewport() ? config.mobileScrub : config.scrub;
    }

    function pointIsInsideSection(clientX, clientY) {
      var rect = root.getBoundingClientRect();
      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
    }

    // Capture scrolling interactions strictly when mouse cursor or touch points are located within visual boundary of the section
    function eventIsInsideSection(event) {
      if (!event) return false;
      if (event.target && interactionElement.contains(event.target)) return true;
      if (event.composedPath && event.composedPath().indexOf(interactionElement) !== -1) return true;
      if (event.touches && event.touches.length) {
        return pointIsInsideSection(event.touches[0].clientX, event.touches[0].clientY);
      }
      if (event.changedTouches && event.changedTouches.length) {
        return pointIsInsideSection(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
      }
      if (typeof event.clientX === "number" && typeof event.clientY === "number") {
        return pointIsInsideSection(event.clientX, event.clientY);
      }
      return root.matches(":hover") || root.contains(document.activeElement);
    }

    function isAnimatingInternally(delta) {
      if (isAnimationCompleted) {
        return false;
      }
      var renderedFrame = Math.round(state.frame);
      if (delta > 0) return targetProgress < 1 || renderedFrame < config.totalFrames - 1;
      if (delta < 0) return targetProgress > 0 || renderedFrame > 0;
      return false;
    }

    function handoffFromIdle() {
      if (idleTween) idleTween.kill();
      idleTween = null;
      targetProgress = Math.max(0, Math.min(1, state.frame / (config.totalFrames - 1)));
      if (hasInteracted) return;
      hasInteracted = true;
    }

    function shouldIdleFromCurrentFrame() {
      var idleProgressEnd = (config.idleLoopEnd - 1) / (config.totalFrames - 1);
      return hasInteracted && Math.round(state.frame) <= config.idleLoopEnd - 1 && targetProgress <= idleProgressEnd;
    }

    function restartIdleFromCurrentFrame() {
      if (idleTween || !shouldIdleFromCurrentFrame()) return;
      if (frameTween) {
        frameTween.kill();
        frameTween = null;
      }
      idleProxy.frame = Math.max(config.idleLoopStart - 1, Math.min(config.idleLoopEnd - 1, state.frame));
      state.frame = idleProxy.frame;
      targetProgress = Math.max(0, Math.min(1, state.frame / (config.totalFrames - 1)));
      startIdle();
    }

    function tweenToProgress(progress) {
      if (progress >= 0.98) {
        isAnimationCompleted = true;
      }
      if (isAnimationCompleted && progress < targetProgress) {
        return;
      }
      targetProgress = Math.max(0, Math.min(1, progress));
      var targetFrame = targetProgress * (config.totalFrames - 1);
      if (frameTween) frameTween.kill();
      frameTween = window.gsap.to(state, {
        frame: targetFrame,
        duration: getActiveScrub(),
        ease: "none",
        onUpdate: function () {
          render(false);
        },
        onComplete: function () {
          render(true);
          restartIdleFromCurrentFrame();
        }
      });
    }

    function applyInputDelta(delta, event) {
      if (!delta) return false;
      if (!eventIsInsideSection(event)) return false;
      var wasIdle = !hasInteracted;
      handoffFromIdle();
      if (!isAnimatingInternally(delta) && !wasIdle) return false;
      tweenToProgress(targetProgress + delta / getVirtualDistance());
      return true;
    }

    function handleWheel(event) {
      if (event.__chuppsMorphHandled) return;
      if (applyInputDelta(event.deltaY, event)) {
        event.__chuppsMorphHandled = true;
        event.preventDefault();
      }
    }

    function handleTouchStart(event) {
      if (event.touches && event.touches.length) {
        lastTouchY = event.touches[0].clientY;
      }
    }

    function handleTouchMove(event) {
      if (!event.touches || !event.touches.length || lastTouchY === null) return;
      var currentY = event.touches[0].clientY;
      var delta = lastTouchY - currentY;
      lastTouchY = currentY;
      if (event.__chuppsMorphHandled) return;
      if (applyInputDelta(delta, event)) {
        event.__chuppsMorphHandled = true;
        event.preventDefault();
      }
    }

    function handleKeydown(event) {
      var deltas = {
        ArrowDown: 80,
        PageDown: window.innerHeight,
        ArrowUp: -80,
        PageUp: -window.innerHeight
      };
      var delta = event.key === " " || event.key === "Spacebar" ? (event.shiftKey ? -window.innerHeight : window.innerHeight) : deltas[event.key];
      if (!delta) return;
      if (applyInputDelta(delta, event)) {
        event.preventDefault();
      }
    }

    function destroy() {
      cancelled = true;
      window.removeEventListener("resize", resize);
      window.removeEventListener("scroll", updateMarginOnScroll);
      interactionElement.removeEventListener("wheel", handleWheel, { capture: true });
      interactionElement.removeEventListener("touchstart", handleTouchStart, { capture: true });
      interactionElement.removeEventListener("touchmove", handleTouchMove, { capture: true });
      window.removeEventListener("wheel", handleWheel, { capture: true });
      window.removeEventListener("touchstart", handleTouchStart, { capture: true });
      window.removeEventListener("touchmove", handleTouchMove, { capture: true });
      window.removeEventListener("keydown", handleKeydown, { capture: true });
      window.removeEventListener("wheel", preventPreloadScroll, { capture: true });
      window.removeEventListener("touchmove", preventPreloadScroll, { capture: true });
      window.removeEventListener("keydown", preventPreloadScroll, { capture: true });
      if (idleTween) idleTween.kill();
      if (frameTween) frameTween.kill();
      if (messageAnimationFrame) window.cancelAnimationFrame(messageAnimationFrame);
      unlockPageScroll();
      root.dataset.chuppsInitialized = "false";
    }

    var idleProxy = { frame: config.idleLoopStart - 1 };

    function startIdle() {
      if (idleTween) idleTween.kill();
      idleTween = window.gsap.to(idleProxy, {
        frame: config.idleLoopEnd - 1,
        duration: config.idleDuration,
        ease: "none",
        repeat: -1,
        yoyo: true,
        onUpdate: function () {
          state.frame = idleProxy.frame;
          render(false);
        }
      });
    }

    function playMobileAutoplay() {
      hasInteracted = true;
      if (idleTween) {
        idleTween.kill();
        idleTween = null;
      }
      var duration = config.mobileAutoPlayDuration || 3.0;
      if (frameTween) frameTween.kill();
      frameTween = window.gsap.to(state, {
        frame: config.totalFrames - 1,
        duration: duration,
        ease: "power1.out",
        onUpdate: function () {
          render(false);
        },
        onComplete: function () {
          render(true);
          isAnimationCompleted = true;
          updateMarginOnScroll();
          
          // Unlock scroll and remove preloader block listeners now that autoplay is finished!
          unlockPageScroll();
          window.removeEventListener("wheel", preventPreloadScroll, { capture: true });
          window.removeEventListener("touchmove", preventPreloadScroll, { capture: true });
          window.removeEventListener("keydown", preventPreloadScroll, { capture: true });
        }
      });
    }

    function playDesktopAutoplay() {
      hasInteracted = true;
      if (idleTween) {
        idleTween.kill();
        idleTween = null;
      }
      var duration = config.desktopAutoPlayDuration || 10.0;
      if (frameTween) frameTween.kill();
      frameTween = window.gsap.to(state, {
        frame: config.totalFrames - 1,
        duration: duration,
        ease: "power1.out",
        onUpdate: function () {
          render(false);
        },
        onComplete: function () {
          render(true);
          isAnimationCompleted = true;
          updateMarginOnScroll();
          
          // Unlock scroll and remove preloader block listeners now that autoplay is finished!
          unlockPageScroll();
          window.removeEventListener("wheel", preventPreloadScroll, { capture: true });
          window.removeEventListener("touchmove", preventPreloadScroll, { capture: true });
          window.removeEventListener("keydown", preventPreloadScroll, { capture: true });
        }
      });
    }

    lockPageScroll();
    updatePreloadProgress(0);
    window.addEventListener("wheel", preventPreloadScroll, { passive: false, capture: true });
    window.addEventListener("touchmove", preventPreloadScroll, { passive: false, capture: true });
    window.addEventListener("keydown", preventPreloadScroll, { passive: false, capture: true });

    loadGeneration += 1;
    loadFrames({
      generation: loadGeneration,
      prefix: activeFramePrefix,
      includeSvgs: true,
      reportProgress: true
    }).then(function () {
      if (cancelled) return;

      window.scrollTo(0, 0);
      resize(true);
      window.addEventListener("resize", resize);
      window.addEventListener("scroll", updateMarginOnScroll, { passive: true });

      var useAutoplay = isMobileViewport() || config.enableDesktopAutoPlay;

      if (!useAutoplay) {
        startIdle();
        interactionElement.addEventListener("wheel", handleWheel, { passive: false, capture: true });
        interactionElement.addEventListener("touchstart", handleTouchStart, { passive: true, capture: true });
        interactionElement.addEventListener("touchmove", handleTouchMove, { passive: false, capture: true });
        window.addEventListener("wheel", handleWheel, { passive: false, capture: true });
        window.addEventListener("touchstart", handleTouchStart, { passive: true, capture: true });
        window.addEventListener("touchmove", handleTouchMove, { passive: false, capture: true });
        window.addEventListener("keydown", handleKeydown, { capture: true });
      }
      window.requestAnimationFrame(function () {
        render(true);
      });

      // Slide-up exit transition sequence
      window.setTimeout(function () {
        // 1. Fade out inner content details first
        preloader.classList.add("fade-out");

        // 2. Slide up the background curtain shortly after
        window.setTimeout(function () {
          preloader.classList.add("loaded");
          
          // 3. Restore window scrolling after curtain sliding finishes
          window.setTimeout(function () {
            if (useAutoplay) {
              // Start the autoplay now that the curtain is fully gone!
              if (isMobileViewport()) {
                playMobileAutoplay();
              } else {
                playDesktopAutoplay();
              }
            } else {
              // On manual desktop, unlock scroll immediately
              unlockPageScroll();
              window.removeEventListener("wheel", preventPreloadScroll, { capture: true });
              window.removeEventListener("touchmove", preventPreloadScroll, { capture: true });
              window.removeEventListener("keydown", preventPreloadScroll, { capture: true });
            }
          }, 1200);
        }, 450);
      }, config.preloaderRevealDelay);
    });

    root.chuppsMorphModelDestroy = destroy;
  }

  function initAll(container) {
    var scope = container || document;
    var sections = scope.matches && scope.matches(SELECTOR) ? [scope] : Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));
    sections.forEach(init);
  }

  function destroySection(sectionId) {
    var root = document.querySelector('[data-chupps-morph-model][data-section-id="' + sectionId + '"]');
    if (root && typeof root.chuppsMorphModelDestroy === "function") {
      root.chuppsMorphModelDestroy();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    window.setTimeout(function () {
      initAll(document);
    }, 0);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    destroySection(event.detail.sectionId);
  });

  window.ChuppsMorphModel = {
    initAll: initAll
  };
})();
